export enum Suffix {
	Mr,
	Mrs,
	Ms,
	Dr
}

export const SuffixNames = {
	[Suffix.Mr]: 'Mr.',
	[Suffix.Mrs]: 'Mrs.',
	[Suffix.Ms]: 'Ms.',
	[Suffix.Dr]: 'Dr.',
};
